export enum RiskLevelTypes {
    HIGH = "High",
    MEDIUM_HIGH = "Medium-High",
    MEDIUM = "Medium",
    MEDIUM_LOW = "Medium-Low",
    LOW = "Low",
    NONE = "None"
}